import { useEffect, useRef, useState } from "react";
import "./index.scss";
import { IPlateNumber } from "../../types/driver.interface";
import CarTag from "./carTag.png";

type Props = {
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  defaultValue: IPlateNumber;
  label?: string;
  isEditable?: boolean;
};

const PlateNumberr = ({
  size = "md",
  defaultValue,
  label,
  isEditable = true,
}: Props) => {
  const [plateNumberIran, setPlateNumberIran] = useState<string | undefined>(
    defaultValue?.iran
  );
  const [plateNumberThreeDigit, setPlateNumberThreeDigit] = useState<
    string | undefined
  >(defaultValue?.threeDigit);
  const [plateNumberLetter, setPlateNumberLetter] = useState<
    string | undefined
  >(defaultValue?.letter);
  const [plateNumberTwoDigit, setPlateNumberTwoDigit] = useState<
    string | undefined
  >(defaultValue?.twoDigit);

  useEffect(() => {
    setPlateNumberIran(defaultValue?.iran);
    setPlateNumberThreeDigit(defaultValue?.threeDigit);
    setPlateNumberLetter(defaultValue?.letter);
    setPlateNumberTwoDigit(defaultValue?.twoDigit);
  }, [defaultValue]);

  const plateNumberIranRef = useRef<HTMLInputElement>(null);
  const plateNumberThreeDigitRef = useRef<HTMLInputElement>(null);
  const plateNumberLetterRef = useRef<HTMLInputElement>(null);
  const plateNumberTwoDigitRef = useRef<HTMLInputElement>(null);
  const plateNumberIranChangeHandler = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = e.target.value;
    !Number.isNaN(value) && setPlateNumberIran(value);
    value === "" && setPlateNumberIran("");
    if (value.length === 2) {
      plateNumberThreeDigitRef.current?.focus();
    }
  };
  const plateNumberThreeDigitChangeHandler = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = e.target.value;
    !Number.isNaN(value) && setPlateNumberThreeDigit(value);
    if (value === "") {
      setPlateNumberThreeDigit("");
      plateNumberIranRef.current?.focus();
    }
    if (value.length === 3) {
      plateNumberLetterRef.current?.focus();
    }
  };
  const plateNumberLetterChangeHandler = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const regex = /^[\u0600-\u06FF]$/;
    const value = e.target.value;
    console.log(value);
    if (value === "") {
      setPlateNumberLetter("");
      plateNumberThreeDigitRef.current?.focus();
    }
    if (regex.test(value)) {
      setPlateNumberLetter(e.target.value);
      plateNumberTwoDigitRef.current?.focus();
    }
  };
  const plateNumberTwoDigitChangeHandler = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = e.target.value;
    if (e.target.value.length <= 2) {
      !Number.isNaN(value) && setPlateNumberTwoDigit(value);
    }
    if (value === "") {
      setPlateNumberTwoDigit("");
      plateNumberLetterRef.current?.focus();
    }
  };

  return (
    <div className={`plateNumber plateNumber-${size}`}>
      {label && <p>شماره پلاک</p>}
      <div className="plateNumber-container">
        <img src={CarTag} alt="" />
        <div className={`plateNumber-container-inputs`}>
          <input
            name="plateNumberIran"
            id="plateNumberIran"
            value={plateNumberIran}
            onChange={plateNumberIranChangeHandler}
            ref={plateNumberIranRef}
            disabled={!isEditable}
          />
          <input
            name="plateNumberThreeDigit"
            id="plateNumberThreeDigit"
            value={plateNumberThreeDigit}
            ref={plateNumberThreeDigitRef}
            onChange={plateNumberThreeDigitChangeHandler}
            disabled={!isEditable}
          />
          <input
            name="plateNumberLetter"
            id="plateNumberLetter"
            value={plateNumberLetter}
            ref={plateNumberLetterRef}
            onChange={plateNumberLetterChangeHandler}
            disabled={!isEditable}
          />
          <input
            name="plateNumberTwoDigit"
            id="plateNumberTwoDigit"
            value={plateNumberTwoDigit}
            ref={plateNumberTwoDigitRef}
            onChange={plateNumberTwoDigitChangeHandler}
            disabled={!isEditable}
          />
        </div>
      </div>
    </div>
  );
};

export default PlateNumberr;
